// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { SiteId } from "features/user-context/slice"
import {
  CreateFavouriteActivityTypeRequest,
  DeleteFavouriteActivityTypeRequest, GetActivityTypeRequest,
  ListRecentActivityTypesRequest,
  ReorderFavouriteActivityTypeRequest,
  SearchActivityTypesRequest,
} from "generated/legebill/site/activitytype/v4/activity_type_pb"

export type FetchFavouriteActivityTypesPayload = {
  siteId: SiteId,
  swallowFailure?: boolean,
}

export type FetchRecentActivityTypesPayload = {
  request: ListRecentActivityTypesRequest,
  swallowFailure?: boolean,
}

export type DeleteFavouriteActivityTypePayload = {
  request: DeleteFavouriteActivityTypeRequest,
  siteId: SiteId,
}

export type ReorderFavouriteActivityTypePayload = {
  request: ReorderFavouriteActivityTypeRequest,
  siteId: SiteId,
}

export const fetchRecentActivityTypes = createAction<FetchRecentActivityTypesPayload>("activity-types/fetch-recent-activity-types")
export const fetchFavouriteActivityTypes = createAction<FetchFavouriteActivityTypesPayload>("activity-types/fetch-favourite-activity-types")
export const searchActivityTypes = createAction<SearchActivityTypesRequest>("activity-types/search-activity-types")
export const createFavouriteActivityType = createAction<CreateFavouriteActivityTypeRequest>("activity-types/create-favourite-activity-type")
export const deleteFavouriteActivityType = createAction<DeleteFavouriteActivityTypePayload>("activity-types/delete-favourite-activity-type")
export const reorderFavouriteActivityType = createAction<ReorderFavouriteActivityTypePayload>("activity-types/reorder-favourite-activity-type")
export const getActivityType = createAction<GetActivityTypeRequest>("activity-types/get-activity-type")

export const orderByPersisted = createAction("activity-types/order-by-persisted")
export const orderByPersistFailed = createAction("activity-types/order-by-persist-failed")
export const recentOrderByPersisted = createAction("activity-types/recent-order-by-persisted")
export const recentOrderByPersistFailed = createAction("activity-types/recent-order-by-persist-failed")
export const viewModePersisted = createAction("activity-types/view-mode-persisted")
export const viewModePersistFailed = createAction("activity-types/view-mode-persist-failed")
export const loadOrderByFromStorage = createAction("activity-types/load-order-by-from-storage")
export const loadOrderByFromStorageFailed = createAction("activity-types/load-order-by-from-storage-failed")
export const loadRecentOrderByFromStorage = createAction("activity-types/load-recent-order-by-from-storage")
export const loadRecentOrderByFromStorageFailed = createAction("activity-types/load-recent-order-by-from-storage-failed")
export const loadViewModeFromStorage = createAction("activity-types/load-view-mode-from-storage")
export const loadViewModeFromStorageFailed = createAction("activity-types/load-view-mode-from-storage-failed")
